import {
  FETCH_PERMISSIONS,
  FETCH_ROLES,
  FETCH_ROLE_PERMISSION_LINKS,
  FETCH_ACTIVE_PERMISSIONS,
  RESET_PERMISSIONS,
  FETCH_NESTED_CATEGORIES
} from "../actions/types";
const INITIAL_STATE = {
  permissions: null,
  roles: null,
  categories: null,
  rolePermissionLinks: null,
  activePermissions: null,
};

 // eslint-disable-next-line
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_PERMISSIONS:
      return {
        ...state,
        permissions: action.payload,
      };
    case FETCH_ROLES:
      return {
        ...state,
        roles: action.payload,
      };
    case FETCH_ROLE_PERMISSION_LINKS:
      return {
        ...state,
        rolePermissionLinks: action.payload,
      };
    case FETCH_ACTIVE_PERMISSIONS:
      return {
        ...state,
        activePermissions: action.payload,
      };
    case RESET_PERMISSIONS:
      return {
        permissions: null,
        roles: null,
        categories: null,
        rolePermissionLinks: null,
        activePermissions: null,
      };
    case FETCH_NESTED_CATEGORIES:
      return{
        ...state,
        categories: action.payload
      };
    default:
      return state;
  }
};
